import { CompetitionStaff } from './competition-staff'
import { Injectable } from '@angular/core'

@Injectable()
export class CompetitionStaffSerializer {
  fromJson(json: any): CompetitionStaff {
    const competitionStaff = {
      ...json
    }

    return competitionStaff
  }

  toJson(competitionStaff: CompetitionStaff): any {
    return {
      ...competitionStaff
    }
  }
}
